export default {
  lang: {
    confirm: {
      title:
        'Sigurado ka bang nais mong tanggalin ito? Hindi mo ito maaaring ibalik pagkatapos ng pagtanggal',
      okText: 'Mangalisa',
      cancelText: 'Kansela',
    },
  },
};
